import { Form, FormGroup, Label, Input, Button } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import Select from "react-select";
import { colourStyles } from "../../utils/customSelectStyle";
import { eventDuration, eventTime,templateName } from "../../utils/constant";
import {createEvent} from "../../api";
import { createOrganizerEvent,deleteEvent } from "../../api";
import { use } from "../../assets/vendor/mixitup/src/module-definitions";
import { getAllCategories } from "../../api";
import { getAllCountries ,createQuickEventV2} from "../../api";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; 
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import NewTicketModal from "./CreateQickEventV2/Components/NewTicketModal";
import TicketList from "./CreateQickEventV2/Components/TicketList";
import ConfirmationDialog from "../../components/common/ConfirmationDialog";
import { EventFormData, TicketData, VenueData, TicketGroupData } from './CreateQickEventV2/types';
import ImageCropper from "../../components/common/ImageCropper/ImageCropper";
import LearnMoreModal from "./CreateQickEventV2/Components/LearnMoreModal";

import Background from "../Login/Background";
import PageHeader from "../../components/common/PageHeader/PageHeader";
import CustomDatePicker from "../../components/common/CustomDatePicker/CustomDatePicker";
import CustomTimePicker from "../../components/common/CustomTimePicker/CustomTimePicker";
import { FileText, Image as ImageIcon, MapPin, Ticket, Settings, Plus, Sparkles, DollarSign, Shield, Info } from "lucide-react";
import { useFreeEventLimit } from "../../hooks/useFreeEventLimit";
import FreeEventLimitNotice from "../../components/common/FreeEventLimitNotice/FreeEventLimitNotice";

const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    [{ 'align': [] }],
    ['link', 'clean']
  ],
};

const quillFormats = [
  'bold', 'italic', 'underline', 'strike',
  'list', 'bullet', 'align', 'link'
];

// Walk nested Formik / Yup / API error objects and return the first message.
const getFirstValidationMessage = (errors: any): string => {
  if (!errors) return "Please fill in all required fields"
  if (typeof errors === "string" && errors.trim()) return errors
  if (Array.isArray(errors)) {
    for (const item of errors) {
      const nested = getFirstValidationMessage(item)
      if (nested && nested !== "Please fill in all required fields") return nested
    }
    return "Please fill in all required fields"
  }
  if (typeof errors === "object") {
    const directMessage = errors.msg || errors.message || errors.error
    if (typeof directMessage === "string" && directMessage.trim()) return directMessage
    for (const value of Object.values(errors)) {
      const nested = getFirstValidationMessage(value)
      if (nested && nested !== "Please fill in all required fields") return nested
    }
  }
  return "Please fill in all required fields"
}

const CreateQuickEvent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isFreeBooking = new URLSearchParams(location.search).get('freeBooking') === 'true';
  const freeEventLimit = useFreeEventLimit(isFreeBooking);
  const [isLoading, setIsLoading] = useState(false);
  const [ticketKind, setTicketType] = useState<'single' | 'group'>('single');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [eventImage, setSelectedThumbImg] = useState<any>(null);
  const [categories,setCategories]= useState<any>([]);
  const [countries,setCountries]= useState<any>([]);
  const [type , setType] = useState<boolean>(false);
  const [editingTicket, setEditingTicket] = useState<TicketData | undefined>(undefined);
  const [ticket, setTickets] = useState<TicketData[]>([]);
  const [ticketGroups, setTicketGroups] = useState<TicketGroupData[]>([]);
  const [venues, setVenues] = useState<VenueData[]>([]);
  const [isCropperOpen, setIsCropperOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [absorbFees, setAbsorbFees] = useState(false);
  const [learnMoreModal, setLearnMoreModal] = useState(false);
  const [learnMoreModalField, setLearnMoreModalField] = useState('');
  // API / submit error shown under the Create Event button
  const [submitError, setSubmitError] = useState('');

  const hasMultipleVenues = false;
  const hasMultipleTicketGroups = false;
  const isTicketFree = isFreeBooking;
  
  const [confirmationDialog, setConfirmationDialog] = useState({
      isOpen: false,
      title: '',
      message: '',
      onConfirm: () => {},
      type: 'warning' as 'warning' | 'danger' | 'info' | 'success'
    });
  const organizerData = localStorage.getItem("organizerData");
  const parsedData = organizerData ? JSON.parse(organizerData) : null;
  let organizerId = parsedData?.organizerId || "";
  let createdBy = parsedData?.organizerId || ""; 
  let processingFee = parsedData?.processingFee || "0.00";
  let ticketFee = parsedData?.ticketFee || "0.00";
  let platformFee = parsedData?.platformFee || "0.00";
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (!file) return;

      if (file.size > 3 * 1024 * 1024) {
        toast.error("File size should be less than 3MB");
        return;
      }

      setSelectedFile(file);
      setIsCropperOpen(true); 
    };



  const validationSchema = Yup.object({
    eventName: Yup.string().required("Event Name is required"),
    eventDate: Yup.string().required("Event Date is required"),
    isSingleDayEvent: Yup.boolean().optional(),
    endDate: Yup.string().when("isSingleDayEvent", {
      is: false,
      then: (schema) => schema.required("End Date is required"),
      otherwise: (schema) => schema.nullable().optional()
    }),
    eventTime: Yup.string().required("Event Start Time is required"),
    endTime: Yup.string().required("Event End Time is required"),
    eventDescription: Yup.string().required("Event Details & Instructions is required"),
    shortDescription: Yup.string().required("Short Share Description is required"),
    venueDetails: Yup.object({
      name: Yup.string().required("Venue details are required"),
    }),
  });

  const formik = useFormik({
    initialValues: {
      eventName: "",
      eventDate: "",
      isSingleDayEvent: true,
      endDate: "",
      eventTime: "",
      endTime: "",
      eventDescription: "",
      eventLocation: "",
      eventImage: "" ,
      shortDescription: "",
      templateType: "corporate",
      categoryName:"",
      countryName :"",
      isOtherAttendeeRequired: false,  
      hasTermsAndConditions: false,
      isPreRegistrationRequired: false,
      termsAndConditions: "",
      venueDetails: {
      name: "",
      venueName: "",
      addressLine1: "",
      addressLine2: "",
      country: "",
      state: "",
      city: "",
      zipCode: "",
      latitude: undefined as number | undefined,
      longitude: undefined as number | undefined,
      formattedAddress: "",
    },
    },
    
    
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (isFreeBooking && (freeEventLimit.isLoading || freeEventLimit.error || freeEventLimit.remaining === 0)) {
        setSubmitError(freeEventLimit.error || 'Limit reached. You cannot create another free event.');
        return;
      }
      if (ticket.length === 0) {
        toast.error("You must create at least one ticket");
        return; 
      }
      setSubmitError('');
      setIsLoading(true);
      try {
       const fd = new FormData();
      fd.append("eventName", values.eventName);
      fd.append("eventDescription", values.eventDescription);
      fd.append("shortDescription", values.shortDescription);
      fd.append("eventLocation", values.venueDetails.name);
      fd.append("categoryId", "11");
      fd.append("organizerId", organizerId);
      fd.append("isTicketFree", String(isFreeBooking ? true : false));
      fd.append("paymentChannel", "our");
      fd.append("paymentUrl", "");
      fd.append("eventType", "offline");
      fd.append("onlineEventType", "offline");
      fd.append("eventStatus", "draft");
      fd.append("eventDate", values.eventDate);
      fd.append("endDate", values.isSingleDayEvent ? (values.eventDate || "") : (values.endDate || values.eventDate || ""));
      fd.append("eventTime", values.eventTime);
      fd.append("eventEndTime", values.endTime);
      fd.append("isSingleDayEvent", String(values.isSingleDayEvent));
      fd.append("createdBy", organizerId);
      fd.append("eventVenue", values.venueDetails.name);
      fd.append("eventAddress1", values.venueDetails.name);
      fd.append("templateType", "corporate");
      fd.append("processingFee", processingFee);
      fd.append("ticketFee", ticketFee);
      fd.append("showOtherFees", isFreeBooking ? "false" : "true");
      fd.append("absorbFees", String(absorbFees));
      fd.append("ticketStatus", "draft");
      fd.append("ticketGrouping", "single_with_grouping");
      fd.append("platformFee", platformFee);
      fd.append("userType", "organizer");
      fd.append("sourceOfCreation","mobile");
      fd.append("isOtherAttendeeRequired", String(values.isOtherAttendeeRequired));
      fd.append("hasTermsAndConditions", String(values.hasTermsAndConditions));
      fd.append("termsAndConditions", values.termsAndConditions || "");
      fd.append("isPreRegistrationRequired", String(values.isPreRegistrationRequired)); 
      fd.append(
        "tickets",
        JSON.stringify(
          ticket.map((t) => ({
            name: t.name,
            type: t.type,
            price: Number(t.price),
            totalTickets: Number(t.totalTickets),
            isActive: t.isActive,
            description: t.description ?? "",
            ticketOrder: t.ticketOrder || ticket.length + 1,
            venueId: t.venueId ?? null,
            groupTicketPrice: t.type === "group" ? Number(t.price) : null,
            isGroupTicket: t.type === "group",
            groupTicketCount: t.groupTicketCount ?? null,
            ticketGroupId: t.ticketGroupId ?? null,
            isOfferActive: t.isOfferActive || false,
            previousAmount: t.previousAmount ?? null,
          }))
        )
      );
      if (eventImage instanceof File) {
        fd.append("eventImage", eventImage, eventImage.name);
      }
      const locationData = venues.length > 0 ? venues.map(venue => ({
        name: venue?.name || '',
        venueName: venue?.name || '',
        addressLine1: venue?.addressLine1 || venue?.formattedAddress || '',
        addressLine2: venue?.addressLine2 || '',
        city: venue?.city || '',
        state: venue?.state || '',
        country: venue?.country || '',
        zipCode: venue?.zipCode || '',
        latitude: venue?.latitude,
        longitude: venue?.longitude,
        formattedAddress: venue?.formattedAddress || venue?.addressLine1 || venue?.name || '',
      })) : [{
        name: values.venueDetails.name,
        venueName: values.venueDetails.venueName || "",
        addressLine1: values.venueDetails.addressLine1 || values.venueDetails.formattedAddress || '',
        addressLine2: values.venueDetails.addressLine2 || '',
        city: values.venueDetails.city,
        state: values.venueDetails.state,
        country: values.venueDetails.country,
        zipCode: values.venueDetails.zipCode,
        latitude: values.venueDetails.latitude,
        longitude: values.venueDetails.longitude,
        formattedAddress: values.venueDetails.formattedAddress || values.venueDetails.addressLine1 || values.venueDetails.name || '',
      }];
      fd.append("locationData", JSON.stringify(locationData));
      fd.append("venueDetails", JSON.stringify(values.venueDetails));
      const response = await createQuickEventV2(fd);
      console.log("createEvent response:", JSON.stringify(response));
      console.log("createEvent fd:", JSON.stringify(fd));
        if (response) {
          toast.success("Event created successfully");
          setTimeout(() => {
          navigate(`/home`);
          }, 2000);
        } else {
          setSubmitError("Failed to create event");
        }
        formik.resetForm();
        setSelectedThumbImg(null);
      }  catch (error: any) {
        console.error("Full error:", error);
        // Show API / backend validation messages under the Create Event button
        const data = error?.response?.data
        setSubmitError(getFirstValidationMessage(data || error) || "Failed to create event")
      }
      finally {
        setIsLoading(false);
      }
    },
  });
  useEffect(() => {
    const getCategories = async () => {
      try {
        const response = await getAllCategories();
        console.log("response", response);
        setCategories(response);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    getCategories();
  }, []);
  useEffect(() => {
    const getCountries = async () => {
      try {
        const response = await getAllCountries();
        console.log("response", response);
        setCountries(response);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    getCountries();
  }, []);
  const closeConfirmationDialog = () => {
    setConfirmationDialog(prev => ({ ...prev, isOpen: false }));
  };
  const handleAbsorbFeesToggle = (newValue: boolean) => {
    if (ticket.length > 0 && absorbFees !== newValue) {
      const feeTypeText = newValue ? 'organizer absorbs fees' : 'attendees pay fees';
      setConfirmationDialog({
        isOpen: true,
        title: 'Change Fee Settings',
        message: `Changing fee settings to <strong>${feeTypeText}</strong> will <strong>permanently delete all ${ticket.length} existing ticket${ticket.length !== 1 ? 's' : ''}</strong>.<br/><br/>Are you sure you want to continue?`,
        onConfirm: () => {
          setAbsorbFees(newValue);
          setTickets([]); // Clear all tickets
        },
        type: 'warning'
      });
    } else {
      setAbsorbFees(newValue);
    }
  };
  const toggleLearnMoreModal = (field: string) => {
    setLearnMoreModalField(field);
    setLearnMoreModal(!learnMoreModal);
  };

  if (isFreeBooking && !freeEventLimit.isLoading && freeEventLimit.remaining === 0) {
    return <Navigate to="/free-event-limit-reached" replace />;
  }

  // Handle opening modal for specific ticket type
  const openModal = (type: 'single' | 'group') => {
    setTicketType(type);
    setIsModalOpen(true);
  };
  const handleTicketSubmit = async (values: any) => {
    setIsLoading(true);
    try {
      const ticketName = values.ticketType || values.name || "Untitled Ticket";
      const ticketPrice = isTicketFree ? 0 : (typeof values.price === 'number' ? values.price : parseFloat(values.price) || 0);
      const parsedMax = values.maxCount === null || values.maxCount === undefined || values.maxCount === 0 || isNaN(values.maxCount) ? null : Number(values.maxCount);

      if (editingTicket) {
        setTickets(prev =>
          prev.map(ticket =>
            ticket.id === editingTicket.id
              ? {
                  ...ticket,
                  name: ticketName,
                  type: ticketKind,
                  description: values.description || '',
                  price: ticketPrice,
                  totalTickets: parsedMax,
                  groupTicketCount: ticketKind === 'group' ? (Number(values.groupTicketCount) || undefined) : undefined,
                  venueId: hasMultipleVenues ? values.venueId : undefined,
                  ticketGroupId: hasMultipleTicketGroups ? values.ticketGroupId : undefined,
                  isOfferActive: values.isOfferActive || false,
                  previousAmount: values.isOfferActive ? (parseFloat(values.previousAmount) || undefined) : undefined,
                  ticketOrder: values.ticketOrder || ticket.ticketOrder,
                }
              : ticket
          )
        );
      } else {
        const newTicket: TicketData = {
          id: Date.now().toString(),
          name: ticketName,
          type: ticketKind,
          description: values.description || '',
          price: ticketPrice,
          totalTickets: parsedMax,
          maxPerCustomer: -1,
          ticketOrder: values.ticketOrder || ticket.length + 1,
          earlyBirdDiscount: false,
          discountAmount: 0,
          discountType: 'percentage',
          discountEndDate: '',
          discountEndTime: '',
          isActive: true,
          groupTicketCount: ticketKind === 'group' ? (Number(values.groupTicketCount) || undefined) : undefined,
          venueId: hasMultipleVenues ? values.venueId : undefined,
          ticketGroupId: hasMultipleTicketGroups ? values.ticketGroupId : undefined,
          isOfferActive: values.isOfferActive || false,
          previousAmount: values.isOfferActive ? (parseFloat(values.previousAmount) || undefined) : undefined,
        };
        setTickets(prev => [...prev, newTicket]);
      }
      setEditingTicket(undefined);
      setIsModalOpen(false);
    } finally {
      setIsLoading(false);
    }
  };
  const onEditTicket = (ticket: TicketData) => {
        setEditingTicket(ticket);
        setTicketType(ticket.type);
        setIsModalOpen(true);
      console.log('onEditTicket', ticket);
    };

    const toggleModal = () => {
      if (isModalOpen) {
        setEditingTicket(undefined);
  
        if (!editingTicket) {
          setTicketType('single');
        }
      }
      setIsModalOpen(!isModalOpen);
      setType(false);
    };
    const handleTicketToggle = (ticketId: string, isActive: boolean) => {
        setTickets(prev => prev.map(ticket =>
          ticket.id === ticketId ? { ...ticket, isActive } : ticket
        ));
      };

      const onDeleteTicket = (ticketId: string) => {
        const ticketToDelete = ticket.find(t => t.id === ticketId);
        if (ticketToDelete) {
          setConfirmationDialog({
            isOpen: true,
            title: "Delete Ticket",
            message: `Are you sure you want to delete <strong>${ticketToDelete.name}</strong>?`,
            onConfirm: () => setTickets(prev => prev.filter(t => t.id !== ticketId)),
            type: "danger",
          });
        }
      };
      const onCheckboxChange = (name: string, value: boolean) => {
        formik.setFieldValue(name, value);
      };
      // Handle Google Map location selection for single venue
      const handleSingleVenueLocationChange = (location: {
      name?: string;
      latitude?: number;
      longitude?: number;
      formattedAddress?: string;
      addressLine1?: string;
      addressLine2?: string;
      country?: string;
      state?: string;
      city?: string;
      zipCode?: string;
    }) => {
      const venueDetails = {
        ...formik.values.venueDetails,
        name: location.name || location.formattedAddress || "",
        addressLine1: location.formattedAddress || "",
        addressLine2: location.addressLine2 || "",
        country: location.country || "",
        state: location.state || "",
        city: location.city || "",
        zipCode: location.zipCode || "",
        latitude: location.latitude,
        longitude: location.longitude,
        formattedAddress: location.formattedAddress || "",
      };
      formik.setFieldValue("venueDetails", venueDetails);
    };

  const eventSettingsSection = (cardStyle: React.CSSProperties) => (
    <div style={cardStyle}>
      <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: 8 }}>
        <Shield size={14} color="#EE3F7C" /> EVENT SETTINGS
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', background: 'rgba(255,255,255,0.02)', padding: '14px 16px', borderRadius: 12, border: '1px solid rgba(255,255,255,0.04)', gap: 16 }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#ffffff' }}>Require Information for All Attendees</div>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.55)', marginTop: 4, lineHeight: 1.65 }}>
              When enabled, customers must provide information for each ticket holder. When disabled, only the primary attendee information is required.
            </div>
          </div>
          <button type="button" className={`v3-toggle ${formik.values.isOtherAttendeeRequired ? "on" : "off"}`} onClick={() => formik.setFieldValue('isOtherAttendeeRequired', !formik.values.isOtherAttendeeRequired)} style={{ flexShrink: 0, marginTop: 2 }}>
            <span className="v3-toggle-knob" />
          </button>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', background: 'rgba(255,255,255,0.02)', padding: '14px 16px', borderRadius: 12, border: '1px solid rgba(255,255,255,0.04)', gap: 16 }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#ffffff' }}>Is Pre-Registration Required?</div>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.55)', marginTop: 4, lineHeight: 1.65 }}>
              When enabled, users must pre-register before they can book tickets.
            </div>
          </div>
          <button type="button" className={`v3-toggle ${formik.values.isPreRegistrationRequired ? "on" : "off"}`} onClick={() => formik.setFieldValue('isPreRegistrationRequired', !formik.values.isPreRegistrationRequired)} style={{ flexShrink: 0, marginTop: 2 }}>
            <span className="v3-toggle-knob" />
          </button>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', background: 'rgba(255,255,255,0.02)', padding: '14px 16px', borderRadius: 12, border: '1px solid rgba(255,255,255,0.04)', gap: 16 }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#ffffff' }}>Add Terms &amp; Conditions</div>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.55)', marginTop: 4, lineHeight: 1.65 }}>
              When enabled, customers must agree to your terms and conditions before completing their booking.
            </div>
          </div>
          <button type="button" className={`v3-toggle ${formik.values.hasTermsAndConditions ? "on" : "off"}`} onClick={() => formik.setFieldValue('hasTermsAndConditions', !formik.values.hasTermsAndConditions)} style={{ flexShrink: 0, marginTop: 2 }}>
            <span className="v3-toggle-knob" />
          </button>
        </div>

        {formik.values.hasTermsAndConditions && (
          <div style={{ background: 'rgba(255,255,255,0.02)', borderRadius: 12, border: '1px solid rgba(255,255,255,0.08)', padding: 2 }}>
            <ReactQuill
              className="text-editor"
              value={formik.values.termsAndConditions}
              onChange={(value) => formik.setFieldValue("termsAndConditions", value)}
              onBlur={() => formik.setFieldTouched("termsAndConditions", true)}
              theme="snow"
            />
          </div>
        )}
      </div>
    </div>
  );

  return (
    <>
      <style>{`
        /* Default to Light Mode */
        .glass-panel {
          --v3-text-main: #0f172a;
          --v3-text-muted: #64748b;
          --v3-text-faint: #94a3b8;
          --v3-bg-subtle: #f8fafc;
          --v3-bg-hover: #f1f5f9;
          --v3-border-subtle: #e2e8f0;
          --v3-border-medium: #cbd5e1;
        }
        
        /* Night Mode Overrides */
        html.night-mode .glass-panel,
        .night-mode .glass-panel {
          --v3-text-main: #ffffff;
          --v3-text-muted: rgba(255,255,255,0.5);
          --v3-text-faint: rgba(255,255,255,0.4);
          --v3-bg-subtle: rgba(255,255,255,0.02);
          --v3-bg-hover: rgba(255,255,255,0.04);
          --v3-border-subtle: rgba(255,255,255,0.05);
          --v3-border-medium: rgba(255,255,255,0.1);
        }
        
        html:not(.night-mode) .v3-poster-box {
           background: var(--v3-bg-hover) !important;
           border-color: var(--v3-border-medium) !important;
        }

        @keyframes v3PageFadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .v3-page-transition {
          animation: v3PageFadeIn 0.22s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        @keyframes v3FeeContentFade {
          from { opacity: 0; transform: translateY(4px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .v3-fee-content-fade {
          animation: v3FeeContentFade 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }

        /* Desktop: form + financial sidebar. Mobile: stack so labels are not crushed. */
        .cqe-layout {
          display: grid;
          grid-template-columns: minmax(0, 1fr) minmax(280px, 380px);
          gap: 28px;
          align-items: start;
        }
        .cqe-layout--single {
          grid-template-columns: minmax(0, 1fr);
        }
        .cqe-sidebar {
          display: flex;
          flex-direction: column;
          width: 100%;
          max-width: 400px;
          min-width: 0;
        }
        .cqe-page-shell {
          max-width: 1280px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          gap: 28px;
          padding: 0 24px;
        }
        @media (max-width: 992px) {
          .cqe-layout {
            grid-template-columns: 1fr;
            gap: 20px;
          }
          .cqe-sidebar {
            max-width: none;
            width: 100%;
          }
          .cqe-page-shell {
            padding: 0 16px;
            gap: 20px;
          }
        }
      `}</style>
      <Background />
      <div className="v3-page-transition" style={{ position: 'relative', zIndex: 1, padding: '36px 0', minHeight: '100vh' }}>
        <div className="container cqe-page-shell">
          
          {/* Header Bar matching reference image */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16, marginBottom: 8 }}>
            <div>
              <h2 style={{ fontSize: 28, fontWeight: 800, color: '#ffffff', margin: 0, display: 'flex', alignItems: 'center', gap: 12 }}>
                <Sparkles size={24} color="#EE3F7C" /> {isFreeBooking ? 'Create Free Event' : 'Create Quick Event'}
              </h2>
              <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', margin: '6px 0 0 0' }}>
                Choose a workflow layout that matches your immediate operational scale.
              </p>
            </div>
            {!isFreeBooking && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
              <div style={{ display: 'flex', background: 'rgba(18, 10, 24, 0.75)', padding: 4, borderRadius: 30, border: '1px solid rgba(255,255,255,0.08)' }}>
                <button
                  type="button"
                  style={{
                    padding: '7px 18px', borderRadius: 20, border: 'none',
                    background: 'linear-gradient(135deg, #EE3F7C, #F79B59)', color: '#fff',
                    fontSize: 12, fontWeight: 700, cursor: 'default',
                    boxShadow: '0 4px 12px rgba(238,63,124,0.3)',
                    transition: 'all 0.2s ease'
                  }}
                >
                  Quick Event (2 min)
                </button>
                <button
                  type="button"
                  onClick={() => navigate(isFreeBooking ? '/create-quick-event-v2?freeBooking=true' : '/create-quick-event-v2')}
                  style={{
                    padding: '7px 18px', borderRadius: 20, border: 'none',
                    background: 'transparent', color: 'rgba(255,255,255,0.5)',
                    fontSize: 12, fontWeight: 700, cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = '#ffffff')}
                  onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(255,255,255,0.5)')}
                >
                  Full Event Studio
                </button>
              </div>
            </div>
            )}
          </div>
          {isFreeBooking && <FreeEventLimitNotice limitInfo={freeEventLimit} />}
          
          <form onSubmit={async (e) => {
            e.preventDefault()
            setSubmitError('')
            const errors = await formik.validateForm()
            // Also toast the first Yup / field validation message on submit
            if (Object.keys(errors).length > 0) {
              formik.setTouched({
                eventName: true,
                eventDate: true,
                endDate: true,
                eventTime: true,
                endTime: true,
                eventDescription: true,
                shortDescription: true,
                venueDetails: { name: true, venueName: true }
              })
              toast.error(getFirstValidationMessage(errors))
              return
            }
            formik.handleSubmit()
          }}>
            <div className={`cqe-layout ${isFreeBooking ? 'cqe-layout--single' : ''}`}>
              
              {/* LEFT MAIN COLUMN */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 28, minWidth: 0 }}>
                
                {/* Card 1: EVENT CORE IDENTIFICATION */}
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 20,
                  padding: 24,
                  background: 'rgba(15, 10, 22, 0.65)',
                  backdropFilter: 'blur(28px)',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  borderRadius: 24,
                  boxShadow: '0 20px 48px rgba(0, 0, 0, 0.4), inset 0 1px 1px rgba(255, 255, 255, 0.1)',
                  position: 'relative',
                  zIndex: 40
                }}>
                  <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <FileText size={14} color="#EE3F7C" /> EVENT INFORMATION
                  </div>

                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 16,
                    padding: 20,
                    background: 'rgba(255, 255, 255, 0.025)',
                    border: '1px solid rgba(255, 255, 255, 0.06)',
                    borderRadius: 16,
                    boxShadow: '0 4px 16px rgba(0,0,0,0.2)'
                  }}>
                    <div>
                      <label className="v3-label">Event Name *</label>
                      <input
                        className="v3-input"
                        type="text"
                        placeholder="e.g. Lost Nightclub"
                        name="eventName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.eventName}
                      />
                      {formik.touched.eventName && formik.errors.eventName && (
                        <div className="text-danger" style={{ fontSize: 12, marginTop: 4 }}>{formik.errors.eventName as string}</div>
                      )}
                    </div>

                    <div>
                      <label className="v3-label">Short Share Description (SEO) *</label>
                      <input
                        className="v3-input"
                        type="text"
                        placeholder="Enter a short description for search engines, social sharing, and event previews."
                        name="shortDescription"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.shortDescription}
                      />
                      {formik.touched.shortDescription && formik.errors.shortDescription && (
                        <div className="text-danger" style={{ fontSize: 12, marginTop: 4 }}>{formik.errors.shortDescription as string}</div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Card 2: SCHEDULE & TIMELINE */}
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 20,
                  padding: 24,
                  background: 'rgba(15, 10, 22, 0.65)',
                  backdropFilter: 'blur(28px)',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  borderRadius: 24,
                  boxShadow: '0 20px 48px rgba(0, 0, 0, 0.4), inset 0 1px 1px rgba(255, 255, 255, 0.1)'
                }}>
                  <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <FileText size={14} color="#EE3F7C" /> SCHEDULE &amp; TIMELINE
                  </div>

                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 16,
                    padding: 20,
                    background: 'rgba(255, 255, 255, 0.025)',
                    border: '1px solid rgba(255, 255, 255, 0.06)',
                    borderRadius: 16,
                    boxShadow: '0 4px 16px rgba(0,0,0,0.2)'
                  }}>
                    <div>
                      <label className="v3-label">DURATION STRUCTURE</label>
                      <div style={{ display: 'flex', gap: 8, background: 'rgba(0,0,0,0.25)', padding: 4, borderRadius: 12, border: '1px solid rgba(255,255,255,0.06)' }}>
                        <button
                          type="button"
                          onClick={() => {
                            formik.setFieldValue("isSingleDayEvent", true);
                            formik.setFieldValue("endDate", "");
                          }}
                          style={{
                            flex: 1, padding: '10px 0', fontSize: 12, fontWeight: 700,
                            borderRadius: 9, cursor: 'pointer', transition: 'all 0.2s',
                            background: formik.values.isSingleDayEvent ? 'linear-gradient(135deg, #EE3F7C, #F79B59)' : 'transparent',
                            border: 'none',
                            color: formik.values.isSingleDayEvent ? '#ffffff' : 'rgba(255,255,255,0.5)',
                            boxShadow: formik.values.isSingleDayEvent ? '0 4px 12px rgba(238,63,124,0.3)' : 'none'
                          }}
                        >Single-Day Event</button>
                        <button
                          type="button"
                          onClick={() => formik.setFieldValue("isSingleDayEvent", false)}
                          style={{
                            flex: 1, padding: '10px 0', fontSize: 12, fontWeight: 700,
                            borderRadius: 9, cursor: 'pointer', transition: 'all 0.2s',
                            background: !formik.values.isSingleDayEvent ? 'linear-gradient(135deg, #EE3F7C, #F79B59)' : 'transparent',
                            border: 'none',
                            color: !formik.values.isSingleDayEvent ? '#ffffff' : 'rgba(255,255,255,0.5)',
                            boxShadow: !formik.values.isSingleDayEvent ? '0 4px 12px rgba(238,63,124,0.3)' : 'none'
                          }}
                        >Multiple-Day Event</button>
                      </div>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16 }}>
                      <div>
                        <label className="v3-label">{formik.values.isSingleDayEvent ? 'EVENT DATE *' : 'START DATE *'}</label>
                        <CustomDatePicker 
                          value={formik.values.eventDate} 
                          onChange={(val) => formik.setFieldValue('eventDate', val)} 
                          placeholder="Select date" 
                        />
                        {formik.touched.eventDate && formik.errors.eventDate && (
                          <div className="text-danger" style={{ fontSize: 12, marginTop: 4 }}>{formik.errors.eventDate as string}</div>
                        )}
                      </div>
                      
                      {!formik.values.isSingleDayEvent && (
                        <div>
                          <label className="v3-label">END DATE *</label>
                          <CustomDatePicker 
                            value={formik.values.endDate} 
                            onChange={(val) => formik.setFieldValue('endDate', val)} 
                            placeholder="Select end date" 
                          />
                          {formik.touched.endDate && formik.errors.endDate && (
                            <div className="text-danger" style={{ fontSize: 12, marginTop: 4 }}>{formik.errors.endDate as string}</div>
                          )}
                        </div>
                      )}
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16 }}>
                      <div>
                        <label className="v3-label">DOORS OPEN *</label>
                        <CustomTimePicker 
                          value={formik.values.eventTime} 
                          onChange={(val) => formik.setFieldValue('eventTime', val)} 
                          placeholder="09:00 AM" 
                        />
                        {formik.touched.eventTime && formik.errors.eventTime && (
                          <div className="text-danger" style={{ fontSize: 12, marginTop: 4 }}>{formik.errors.eventTime as string}</div>
                        )}
                      </div>
                      <div>
                        <label className="v3-label">EVENT CONCLUSION *</label>
                        <CustomTimePicker 
                          value={formik.values.endTime} 
                          onChange={(val) => formik.setFieldValue('endTime', val)} 
                          placeholder="05:00 PM" 
                        />
                        {formik.touched.endTime && formik.errors.endTime && (
                          <div className="text-danger" style={{ fontSize: 12, marginTop: 4 }}>{formik.errors.endTime as string}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Card 3: EVENT COVER POSTER */}
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 20,
                  padding: 24,
                  background: 'rgba(15, 10, 22, 0.65)',
                  backdropFilter: 'blur(28px)',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  borderRadius: 24,
                  boxShadow: '0 20px 48px rgba(0, 0, 0, 0.4), inset 0 1px 1px rgba(255, 255, 255, 0.1)'
                }}>
                  <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <ImageIcon size={14} color="#EE3F7C" /> EVENT COVER POSTER
                  </div>

                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 16,
                    padding: 20,
                    background: 'rgba(255, 255, 255, 0.025)',
                    border: '1px solid rgba(255, 255, 255, 0.06)',
                    borderRadius: 16,
                    boxShadow: '0 4px 16px rgba(0,0,0,0.2)'
                  }}>
                    <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', margin: 0, lineHeight: 1.5 }}>
                      Upload colorful and vibrant images as the banner for your event! See how beautiful images help your event details page.
                    </p>
                    
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20, alignItems: 'stretch', width: '100%' }}>
                      <div style={{ width: 160, maxWidth: '100%', flexShrink: 0 }}>
                        <div className="v3-poster-box" onClick={() => fileInputRef.current?.click()} style={{ cursor: 'pointer', borderRadius: 14, overflow: 'hidden', border: '1px dashed rgba(255,255,255,0.15)', width: '100%', aspectRatio: '3/4', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.02)' }}>
                          {eventImage ? (
                            <img src={URL.createObjectURL(eventImage)} alt="Cover Preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                          ) : (
                            <div style={{ textAlign: 'center', padding: 16, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
                              <ImageIcon size={28} color="rgba(255,255,255,0.3)" />
                              <div>
                                <span style={{ fontSize: 10, fontFamily: 'monospace', color: '#ffffff', textTransform: 'uppercase', letterSpacing: '0.1em', fontWeight: 700, display: 'block' }}>No Poster</span>
                              </div>
                            </div>
                          )}
                        </div>
                        <input ref={fileInputRef} id="poster-file" type="file" accept="image/jpeg, image/png" style={{ display: 'none' }} onChange={handleImageUpload} />
                      </div>
                      
                      <div style={{ flex: '1 1 240px', display: 'flex' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', padding: 18, background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.04)', borderRadius: 14, width: '100%', boxSizing: 'border-box' }}>
                          <span style={{ fontSize: 10, fontFamily: 'monospace', color: '#F79B59', textTransform: 'uppercase', letterSpacing: '0.1em', fontWeight: 600, marginBottom: 14 }}>Poster Controls</span>
                          
                          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 16 }}>
                            {!eventImage ? (
                              <button type="button" onClick={() => fileInputRef.current?.click()} className="v3-btn-primary" style={{ fontSize: 12, padding: '10px 16px', flex: 1, minWidth: 120 }}>
                                <ImageIcon size={14} /> Upload Image
                              </button>
                            ) : (
                              <>
                                <button type="button" onClick={() => fileInputRef.current?.click()} className="v3-btn-secondary" style={{ fontSize: 12, flex: 1, minWidth: 110 }}>Replace Poster</button>
                                <button type="button" onClick={() => { formik.setFieldValue("eventImage", null); setSelectedThumbImg(null); }} className="v3-btn-secondary" style={{ fontSize: 12, flex: 1, minWidth: 110, color: '#FF5D73', borderColor: 'rgba(255,93,115,0.2)' }}>Remove Poster</button>
                              </>
                            )}
                          </div>

                          <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: 12, marginTop: 'auto' }}>
                            <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', fontStyle: 'italic', marginBottom: 4 }}>It is preferred to have a 3:4 portrait ratio image.</p>
                            <p style={{ fontSize: 9, fontFamily: 'monospace', color: 'rgba(238,63,124,0.7)', textTransform: 'uppercase', letterSpacing: '0.1em', fontWeight: 600, margin: 0 }}>Max Size: 3MB</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {formik.touched.eventImage && formik.errors.eventImage && (
                      <div className="text-danger" style={{ fontSize: 12, marginTop: 4 }}>{formik.errors.eventImage as string}</div>
                    )}
                  </div>
                </div>

                {/* Card 4: LOCATION & VENUE */}
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 20,
                  padding: 24,
                  background: 'rgba(15, 10, 22, 0.65)',
                  backdropFilter: 'blur(28px)',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  borderRadius: 24,
                  boxShadow: '0 20px 48px rgba(0, 0, 0, 0.4), inset 0 1px 1px rgba(255, 255, 255, 0.1)',
                  position: 'relative',
                  zIndex: 30
                }}>
                  <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <MapPin size={14} color="#EE3F7C" /> LOCATION &amp; VENUE
                  </div>

                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 16,
                    padding: 20,
                    background: 'rgba(255, 255, 255, 0.025)',
                    border: '1px solid rgba(255, 255, 255, 0.06)',
                    borderRadius: 16,
                    boxShadow: '0 4px 16px rgba(0,0,0,0.2)'
                  }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 16 }}>
                      <div>
                        <label className="v3-label">VENUE NAME *</label>
                        <input
                          className="v3-input"
                          type="text"
                          placeholder="Enter venue name"
                          value={formik.values.venueDetails.venueName || ""}
                          onChange={(e) => formik.setFieldValue('venueDetails', { ...formik.values.venueDetails, venueName: e.target.value })}
                        />
                        {formik.touched.venueDetails && (formik.errors.venueDetails as any)?.name && (
                          <div className="text-danger" style={{ fontSize: 12, marginTop: 4 }}>{(formik.errors.venueDetails as any).name}</div>
                        )}
                      </div>
                      <div>
                        <label className="v3-label">EVENT LOCATION *</label>
                        <GooglePlacesAutocomplete
                          apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""}
                          selectProps={{
                            placeholder: "Search for a location or address...",
                            isClearable: true,
                            value: formik.values.venueDetails?.addressLine1 ? {
                              label: formik.values.venueDetails.addressLine1,
                              value: {
                                description: formik.values.venueDetails.addressLine1,
                                place_id: '',
                                geometry: { location: { lat: formik.values.venueDetails.latitude, lng: formik.values.venueDetails.longitude } }
                              }
                            } : null,
                            onChange: (place: any) => {
                              if (place) {
                                const placeDetails = {
                                  name: place.label || "",
                                  formattedAddress: place.label || "",
                                  addressLine1: place.value?.description || "",
                                  addressLine2: "", country: "", state: "", city: "", zipCode: "",
                                  latitude: place.value?.geometry?.location?.lat,
                                  longitude: place.value?.geometry?.location?.lng,
                                };

                                if (place.value?.place_id) {
                                  const geocoder = new google.maps.Geocoder();
                                  geocoder.geocode({ placeId: place.value.place_id }, (results, status) => {
                                    if (status === "OK" && results && results[0]) {
                                      const result = results[0];
                                      const addressComponents = result.address_components;
                                      const placeDetailsEnhanced = {
                                        name: place.label || "",
                                        formattedAddress: result.formatted_address || place.label || "",
                                        addressLine1: result.formatted_address || place.value?.description || "",
                                        addressLine2: "", country: "", state: "", city: "", zipCode: "",
                                        latitude: result.geometry?.location?.lat(),
                                        longitude: result.geometry?.location?.lng(),
                                      };
                                      addressComponents.forEach((component) => {
                                        const types = component.types;
                                        if (types.includes("country")) placeDetailsEnhanced.country = component.long_name;
                                        else if (types.includes("administrative_area_level_1")) placeDetailsEnhanced.state = component.long_name;
                                        else if (types.includes("locality")) placeDetailsEnhanced.city = component.long_name;
                                        else if (types.includes("postal_code")) placeDetailsEnhanced.zipCode = component.long_name;
                                        else if (types.includes("route")) placeDetailsEnhanced.addressLine1 = component.long_name;
                                        else if (types.includes("street_number")) placeDetailsEnhanced.addressLine1 = component.long_name + " " + placeDetailsEnhanced.addressLine1;
                                      });
                                      formik.setFieldValue('venueDetails', placeDetailsEnhanced);
                                    } else {
                                      formik.setFieldValue('venueDetails', placeDetails);
                                    }
                                  });
                                } else {
                                  formik.setFieldValue('venueDetails', placeDetails);
                                }
                              } else {
                                formik.setFieldValue('venueDetails', {
                                  name: '', formattedAddress: '', addressLine1: '', addressLine2: '',
                                  country: '', state: '', city: '', zipCode: '', latitude: undefined, longitude: undefined,
                                });
                              }
                            },
                            styles: {
                              control: (provided: any, state: any) => ({
                                ...provided,
                                backgroundColor: 'rgba(255,255,255,0.04)',
                                borderColor: state.isFocused ? '#EE3F7C' : 'rgba(255,255,255,0.08)',
                                borderRadius: "12px", minHeight: "44px", boxShadow: "none", color: '#ffffff',
                                "&:hover": { borderColor: "rgba(238, 63, 124, 0.4)" },
                              }),
                              input: (provided: any) => ({ ...provided, color: '#ffffff', fontSize: "13px" }),
                              singleValue: (provided: any) => ({ ...provided, color: '#ffffff', fontSize: "13px" }),
                              placeholder: (provided: any) => ({ ...provided, color: "rgba(255,255,255,0.4)", fontSize: "13px" }),
                              menu: (provided: any) => ({
                                ...provided, backgroundColor: "rgba(18, 18, 28, 0.98)", backdropFilter: "blur(24px)",
                                border: '1px solid rgba(255,255,255,0.1)', borderRadius: "14px", zIndex: 99999, padding: "6px",
                                boxShadow: "0 20px 48px rgba(0, 0, 0, 0.5)",
                              }),
                              option: (provided: any, state: any) => ({
                                ...provided, backgroundColor: state.isSelected ? "rgba(238, 63, 124, 0.2)" : state.isFocused ? "rgba(255,255,255,0.04)" : "transparent",
                                color: '#ffffff', fontSize: "13px", borderRadius: "8px", cursor: "pointer",
                              }),
                            },
                          }}
                        />
                      </div>
                    </div>

                    {formik.values.venueDetails?.name && (
                      <div style={{ padding: 16, borderRadius: 12, background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.04)', display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 14 }}>
                        <div style={{ display: "flex", alignItems: "flex-start", gap: 14 }}>
                          <div style={{ width: 60, height: 60, borderRadius: 10, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', flexShrink: 0, position: "relative", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <img src="https://images.unsplash.com/photo-1569336415962-a4bd9f69cd83?w=200&auto=format&fit=crop&q=80" alt="Map" style={{ width: "100%", height: "100%", objectFit: "cover", filter: "brightness(0.7) contrast(1.25)" }} />
                            <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <MapPin size={20} color="#EE3F7C" />
                            </div>
                          </div>
                          <div>
                            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                              <span style={{ fontSize: 13, fontWeight: 700, color: '#ffffff' }}>{formik.values.venueDetails.name}</span>
                              <span style={{ fontSize: 9, fontFamily: "monospace", padding: "2px 8px", borderRadius: 4, border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.05)', color: 'rgba(255,255,255,0.6)' }}>Selected</span>
                            </div>
                            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginTop: 4 }}>
                              {formik.values.venueDetails.addressLine1}
                              {formik.values.venueDetails.city && `, ${formik.values.venueDetails.city}`}
                              {formik.values.venueDetails.state && `, ${formik.values.venueDetails.state}`}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Card 5: EVENT DETAILS & INSTRUCTIONS */}
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 20,
                  padding: 24,
                  background: 'rgba(15, 10, 22, 0.65)',
                  backdropFilter: 'blur(28px)',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  borderRadius: 24,
                  boxShadow: '0 20px 48px rgba(0, 0, 0, 0.4), inset 0 1px 1px rgba(255, 255, 255, 0.1)'
                }}>
                  <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <FileText size={14} color="#EE3F7C" /> EVENT DETAILS &amp; INSTRUCTIONS
                  </div>

                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 16,
                    padding: 20,
                    background: 'rgba(255, 255, 255, 0.025)',
                    border: '1px solid rgba(255, 255, 255, 0.06)',
                    borderRadius: 16,
                    boxShadow: '0 4px 16px rgba(0,0,0,0.2)'
                  }}>
                    <div>
                      <label className="v3-label">Event Details &amp; Instructions *</label>
                      <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', margin: '4px 0 10px 0' }}>
                        Provide extra information such as schedules, itinerary or special instructions.
                      </p>
                      <div style={{ background: 'rgba(255,255,255,0.02)', borderRadius: 12, border: '1px solid rgba(255,255,255,0.08)', padding: 2 }}>
                        <ReactQuill
                          className="text-editor"
                          value={formik.values.eventDescription}
                          onChange={(value) => formik.setFieldValue("eventDescription", value)}
                          onBlur={() => formik.setFieldTouched("eventDescription", true)}
                          theme="snow"
                        />
                      </div>
                      {formik.touched.eventDescription && formik.errors.eventDescription && (
                        <div className="text-danger" style={{ fontSize: 12, marginTop: 4 }}>{formik.errors.eventDescription as string}</div>
                      )}
                    </div>
                  </div>
                </div>



                {/* Card 6: TICKETS ARCHITECT */}
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 20,
                  padding: 24,
                  background: 'rgba(15, 10, 22, 0.65)',
                  backdropFilter: 'blur(28px)',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  borderRadius: 24,
                  boxShadow: '0 20px 48px rgba(0, 0, 0, 0.4), inset 0 1px 1px rgba(255, 255, 255, 0.1)'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 14 }}>
                    <div>
                      <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Ticket size={14} color="#EE3F7C" /> TICKETS ({ticket.length})
                      </div>
                      <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', margin: "4px 0 0 0" }}>
                        Configure single entry or group packages.
                      </p>
                    </div>
                    <div style={{ display: 'flex', gap: 10 }}>
                      <button type="button" className="v3-btn-secondary" style={{ fontSize: 12, padding: '9px 18px' }} onClick={() => { setTicketType('single'); setIsModalOpen(true); }}>
                        + Single Ticket
                      </button>
                      <button type="button" className="v3-btn-secondary" style={{ fontSize: 12, padding: '9px 18px' }} onClick={() => { setTicketType('group'); setIsModalOpen(true); }}>
                        + Group Ticket
                      </button>
                    </div>
                  </div>

                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 16,
                    padding: 20,
                    background: 'rgba(255, 255, 255, 0.025)',
                    border: '1px solid rgba(255, 255, 255, 0.06)',
                    borderRadius: 16,
                    boxShadow: '0 4px 16px rgba(0,0,0,0.2)'
                  }}>
                    {ticket.length === 0 ? (
                      <div style={{ padding: "32px 20px", textAlign: "center", borderRadius: 14, background: 'rgba(255,255,255,0.02)', border: '1px dashed rgba(255,255,255,0.08)' }}>
                        <Ticket size={30} color="rgba(255,255,255,0.3)" style={{ margin: "0 auto 10px auto", display: "block" }} />
                        <div style={{ fontSize: 13, fontWeight: 700, color: '#ffffff' }}>No tickets created yet</div>
                        <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', marginTop: 4, marginBottom: 14 }}>Click above to create custom tickets.</p>
                      </div>
                    ) : (
                      <TicketList
                        tickets={ticket}
                        hasMultipleVenues={hasMultipleVenues}
                        venues={venues}
                        hasMultipleTicketGroups={hasMultipleTicketGroups}
                        ticketGroups={ticketGroups}
                        onTicketToggle={(ticketId, isActive) => {
                          const updatedTickets = ticket.map(t => t.id === ticketId ? { ...t, isActive } : t);
                          setTickets(updatedTickets);
                        }}
                        onEditTicket={(t) => {
                          setEditingTicket(t);
                          setTicketType(t.type === 'group' ? 'group' : 'single');
                          setIsModalOpen(true);
                        }}
                        onDeleteTicket={(ticketId) => {
                          setTickets(ticket.filter(t => t.id !== ticketId));
                        }}
                        onReorderTickets={(reorderedTickets) => {
                          setTickets(reorderedTickets);
                        }}
                      />
                    )}
                  </div>
                </div>

                {/* Create Event Action & Draft Information (Button first, then subtle helper text below) */}
                <div style={{ display: 'none', flexDirection: 'column', gap: 14, alignItems: 'center', textAlign: 'center', marginTop: 12 }}>
                  <button
                    className="v3-btn-primary shadow-glow"
                    type="submit"
                    disabled={isLoading}
                    style={{ width: '100%', maxWidth: 400, padding: '15px 32px', fontSize: 16, fontWeight: 700, borderRadius: 30, justifyContent: 'center' }}
                  >
                    {isLoading ? "Creating Event..." : "Create Event"}
                  </button>
                </div>

              </div>

{/* RIGHT SIDEBAR COLUMN (Premium Dashboard Composition) — hidden in free booking mode */}
              {!isFreeBooking && (
              <div className="cqe-sidebar">
                
                {/* Outer Premium Glass Container */}
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 20,
                  padding: 24,
                  background: 'rgba(15, 10, 22, 0.65)',
                  backdropFilter: 'blur(28px)',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  borderRadius: 24,
                  boxShadow: '0 20px 48px rgba(0, 0, 0, 0.4), inset 0 1px 1px rgba(255,255,255,0.1)'
                }}>
                  
                  {/* Inner Card 1: FINANCIAL & AUDIENCE EST. */}
                  <div style={{
                    display: isTicketFree ? 'none' : 'flex',
                    flexDirection: 'column',
                    gap: 16,
                    padding: 20,
                    background: 'rgba(255, 255, 255, 0.025)',
                    border: '1px solid rgba(255, 255, 255, 0.06)',
                    borderRadius: 16,
                    boxShadow: '0 4px 16px rgba(0,0,0,0.2)'
                  }}>
                    <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: 8 }}>
                      <DollarSign size={14} color="#EE3F7C" /> FINANCIAL &amp; AUDIENCE EST.
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'rgba(255,255,255,0.02)', padding: '10px 14px', borderRadius: 10, border: '1px solid rgba(255,255,255,0.04)' }}>
                        <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)' }}>Allocated Seating Capacity</span>
                        <span style={{ fontSize: 13, fontWeight: 700, color: '#ffffff', display: 'flex', alignItems: 'center', gap: 6 }}>
                          <span style={{ color: '#F79B59', fontSize: 11 }}>⏳</span> {ticket.reduce((sum, t) => sum + (Number(t.totalTickets) || Number((t as any).maxCount) || Number((t as any).quantity) || 0), 0).toLocaleString()} seats
                        </span>
                      </div>

                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'rgba(255,255,255,0.02)', padding: '10px 14px', borderRadius: 10, border: '1px solid rgba(255,255,255,0.04)' }}>
                        <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)' }}>Active Price Tiers</span>
                        <span style={{ fontSize: 13, fontWeight: 700, color: '#ffffff' }}>{ticket.length} configured structures</span>
                      </div>

                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'linear-gradient(135deg, rgba(238,63,124,0.1), rgba(247,155,89,0.05))', padding: '12px 14px', borderRadius: 12, border: '1px solid rgba(238,63,124,0.2)' }}>
                        <span style={{ fontSize: 12, fontWeight: 600, color: 'rgba(255,255,255,0.85)' }}>Potential Net Revenue Target</span>
                        <span style={{ fontSize: 18, fontWeight: 800, color: '#EE3F7C' }}>
                          $ {ticket.reduce((sum, t) => sum + ((Number(t.price) || 0) * (Number(t.totalTickets) || Number((t as any).maxCount) || Number((t as any).quantity) || 0)), 0).toLocaleString()}
                        </span>
                      </div>
                    </div>

                    <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.45)', margin: '4px 0 0 0', lineHeight: 1.5 }}>
                      Estimates are automatically calculated based on your configured ticket prices, ticket quantities, and active ticket tiers. Values update automatically as your ticket configuration changes.
                    </p>
                  </div>

                  {/* Inner Card 2: TICKETING FEE RULES */}
                  <div style={{
                    display: isTicketFree ? 'none' : 'flex',
                    flexDirection: 'column',
                    gap: 20,
                    padding: 22,
                    background: 'rgba(255, 255, 255, 0.025)',
                    border: '1px solid rgba(255, 255, 255, 0.06)',
                    borderRadius: 16,
                    boxShadow: '0 4px 16px rgba(0,0,0,0.2)'
                  }}>
                    <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: 8 }}>
                      <DollarSign size={14} color="#EE3F7C" /> TICKETING FEE RULES
                    </div>

                    <div style={{ display: 'flex', gap: 8, background: 'rgba(0,0,0,0.25)', padding: 5, borderRadius: 14, border: '1px solid rgba(255,255,255,0.06)' }}>
                      <button
                        type="button"
                        onClick={() => handleAbsorbFeesToggle(false)}
                        style={{
                          flex: 1, padding: '11px 0', fontSize: 12, fontWeight: 700,
                          borderRadius: 10, cursor: 'pointer', transition: 'all 0.2s',
                          background: !absorbFees ? 'linear-gradient(135deg, #EE3F7C, #F79B59)' : 'transparent',
                          border: 'none',
                          color: !absorbFees ? '#ffffff' : 'rgba(255,255,255,0.5)',
                          boxShadow: !absorbFees ? '0 4px 12px rgba(238,63,124,0.3)' : 'none'
                        }}
                      >Attendee Pays</button>
                      <button
                        type="button"
                        onClick={() => handleAbsorbFeesToggle(true)}
                        style={{
                          flex: 1, padding: '11px 0', fontSize: 12, fontWeight: 700,
                          borderRadius: 10, cursor: 'pointer', transition: 'all 0.2s',
                          background: absorbFees ? 'linear-gradient(135deg, #EE3F7C, #F79B59)' : 'transparent',
                          border: 'none',
                          color: absorbFees ? '#ffffff' : 'rgba(255,255,255,0.5)',
                          boxShadow: absorbFees ? '0 4px 12px rgba(238,63,124,0.3)' : 'none'
                        }}
                      >Organizer Pays</button>
                    </div>

                    {/* Dynamic Fee Explanation Sub-Card with Premium Glass Styling & Generous Padding */}
                    <div key={absorbFees ? 'organizer' : 'attendee'} className="v3-fee-content-fade" style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 0,
                      padding: '22px 24px',
                      background: 'rgba(255, 255, 255, 0.025)',
                      border: '1px solid rgba(255, 255, 255, 0.06)',
                      borderRadius: 16,
                      boxShadow: '0 4px 16px rgba(0,0,0,0.2), inset 0 1px 1px rgba(255,255,255,0.03)',
                      transition: 'all 0.2s ease-in-out'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, width: '100%' }}>
                        <span style={{ fontSize: 13, fontWeight: 700, color: '#ffffff', whiteSpace: 'nowrap', lineHeight: 1.2 }}>
                          {absorbFees ? 'Organizer Absorbs Fees' : 'Attendee Pays Fees'}
                        </span>
                        <button
                          type="button"
                          onClick={() => { setLearnMoreModalField('absorbFees'); setLearnMoreModal(true); }}
                          style={{
                            background: 'none', border: 'none', padding: 0, fontSize: 11, fontWeight: 600,
                            color: '#EE3F7C', cursor: 'pointer', textDecoration: 'none', transition: 'color 0.15s',
                            whiteSpace: 'nowrap', marginLeft: 'auto', flexShrink: 0, lineHeight: 1.2
                          }}
                          onMouseEnter={(e) => (e.currentTarget.style.color = '#F79B59')}
                          onMouseLeave={(e) => (e.currentTarget.style.color = '#EE3F7C')}
                        >
                          Learn more
                        </button>
                      </div>
                      <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.55)', margin: '10px 0 0 0', lineHeight: 1.65, textAlign: 'left', wordBreak: 'break-word' }}>
                        {absorbFees
                          ? "When enabled, ticketing fees are deducted from your ticket revenue. Otherwise, they are added to the attendee's checkout total."
                          : "Ticketing fees are added to the attendee's checkout total. You receive the full face-value amount of each ticket sold."}
                      </p>
                    </div>
                  </div>

                  {/* Inner Card 3: EVENT SETTINGS (moved to bottom for freebooking only) */}
                  {isFreeBooking ? null : eventSettingsSection({ display: 'flex', flexDirection: 'column', gap: 16, padding: 20, background: 'rgba(255, 255, 255, 0.025)', border: '1px solid rgba(255, 255, 255, 0.06)', borderRadius: 16, boxShadow: '0 4px 16px rgba(0,0,0,0.2)' })}

                </div>

              </div>
              )}

            </div>

            {isFreeBooking && eventSettingsSection({ display: 'flex', flexDirection: 'column', gap: 20, padding: 24, background: 'rgba(15, 10, 22, 0.65)', backdropFilter: 'blur(28px)', border: '1px solid rgba(255, 255, 255, 0.08)', borderRadius: 24, boxShadow: '0 20px 48px rgba(0, 0, 0, 0.4), inset 0 1px 1px rgba(255,255,255,0.1)' })}

            <div style={{ display: 'flex', flexDirection: 'column', gap: 14, alignItems: 'center', textAlign: 'center', marginTop: 12 }}>
              <button
                className="v3-btn-primary shadow-glow"
                type="submit"
                disabled={isLoading}
                style={{ width: '100%', maxWidth: 400, padding: '15px 32px', fontSize: 16, fontWeight: 700, borderRadius: 30, justifyContent: 'center' }}
              >
                {isLoading ? "Creating Event..." : "Create Event"}
              </button>
              {submitError && (
                <div
                  className="text-danger"
                  role="alert"
                  style={{ fontSize: 13, fontWeight: 600, maxWidth: 400, lineHeight: 1.45 }}
                >
                  {submitError}
                </div>
              )}
            </div>
          </form>
        </div>
      </div>

      {isCropperOpen && selectedFile && (
        <div className="cropper-modal-overlay" style={{ position: 'fixed', inset: 0, zIndex: 999999, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(8px)' }}>
          <div className="cropper-modal-card" style={{ background: '#12121c', padding: 24, borderRadius: 16, border: '1px solid var(--v3-border-medium)', width: '90%', maxWidth: 600 }}>
            <ImageCropper
              imageFile={selectedFile}
              aspect={3 / 4}
              onCancel={() => setIsCropperOpen(false)}
              onCropComplete={(croppedFile) => {
                formik.setFieldValue("eventImage", croppedFile);
                setSelectedThumbImg(croppedFile); 
                setIsCropperOpen(false);
              }}
            />
          </div>
        </div>
      )}

      <NewTicketModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        onSubmit={handleTicketSubmit}
        isLoading={isLoading}
        ticketKind={ticketKind}   
        hasMultipleVenues={hasMultipleVenues}
        venues={venues}
        hasMultipleTicketGroups={hasMultipleTicketGroups}
        ticketGroups={ticketGroups}
        isTicketFree={isTicketFree}
        editingTicket={editingTicket}
        type={type}
      />
      <ConfirmationDialog
        isOpen={confirmationDialog.isOpen}
        toggle={closeConfirmationDialog}
        onConfirm={confirmationDialog.onConfirm}
        title={confirmationDialog.title}
        message={confirmationDialog.message}
        type={confirmationDialog.type}
        confirmText="Yes, Continue"
        cancelText="Cancel"
        icon="fa-solid fa-exclamation-triangle"
      />
      <LearnMoreModal
        isOpen={learnMoreModal}
        toggle={() => setLearnMoreModal(false)}
        field={learnMoreModalField}
        fieldValue={absorbFees}
      />
      <ToastContainer autoClose={2000} />
    </>
  );
};
export default CreateQuickEvent;
